import React, { useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import MasterPasswordDialog from "../MasterPasswordDialog";

export default function ClosedOrdersPasswordGate({ posProfile, open, children, onClose }) {
    if (!posProfile) return null;
    if (Number(posProfile.rm_require_master_password_for_closed_orders) !== 1) {
        return children;
    }
    if (!open) return null;
    return (
        <PasswordChallenge key={posProfile.name} onClose={onClose}>
            {children}
        </PasswordChallenge>
    );
}

// Mounted for one opening only; children (and their queries) stay unmounted
// until the server validates the same password used for elevated privileges.
function PasswordChallenge({ children, onClose }) {
    const { t } = useTranslation();
    const [authorized, setAuthorized] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const pending = useRef(false);

    const confirm = async (password) => {
        if (pending.current || !password.trim()) return;
        pending.current = true;
        setLoading(true);
        setError(false);
        try {
            const { data } = await axios.post(
                "method/restaurant_management.api.validate_closed_orders_master_password",
                { master_password: password }
            );
            if (data.message !== true) throw new Error("Password validation failed");
            setAuthorized(true);
        } catch {
            setError(true);
        } finally {
            pending.current = false;
            setLoading(false);
        }
    };

    if (authorized) return children;
    return (
        <MasterPasswordDialog
            open
            title={t("closedOrders.passwordTitle")}
            message={t(error ? "closedOrders.passwordError" : "closedOrders.passwordMessage")}
            onConfirm={confirm}
            onClose={onClose}
            loading={loading}
        />
    );
}
